export class HistoricalFulfillmentTime {
    constructor(stats) {
        this.statsByMethod = new Map(stats.map((s) => [
            s.fulfillmentMethod,
            {
                median: s.estimatedMinutes,
                low: s.estimatedMinutesLow,
                high: s.estimatedMinutesHigh,
            },
        ]));
    }
    getData(method) {
        var _a;
        if (method === null)
            return null;
        const key = method === "NoContactDelivery" ? "Delivery" : method;
        return (_a = this.statsByMethod.get(key)) !== null && _a !== void 0 ? _a : null;
    }
    get hasData() {
        return this.statsByMethod.size > 0;
    }
    getMedianMinutes(method) {
        var _a, _b;
        return (_b = (_a = this.getData(method)) === null || _a === void 0 ? void 0 : _a.median) !== null && _b !== void 0 ? _b : null;
    }
    getEstimatedRange(method) {
        const data = this.getData(method);
        if (data === null)
            return null;
        return { low: data.low, high: data.high };
    }
}
